import React from 'react';
import { Grid } from '@abyss/web/ui/Grid';
import { TextInput } from '@abyss/web/ui/TextInput';
import { SetUserController } from './SetUser.Controller';
import { Button } from '@abyss/web/ui/Button';
import { FormProvider } from '@abyss/web/ui/FormProvider';

export const SetUser: React.FC = () => {
  const controller = SetUserController();

  return (
    <FormProvider state={controller.form}>
      <Grid>
        <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid>
            <Grid.Col span={{ xs: 12 }}>
              <TextInput
                label="Display Name"
                model="displayName"
                maxLength={100}
                validators={{
                  required: 'Display Name is required',
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ xs: 12 }}>
              <TextInput
                label="Initials"
                model="initials"
                maxLength={2}
                validators={{
                  required: 'Initials are required',
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ xs: 12 }}>
              <Button type="submit" onClick={controller.Action.ApplyClick}>
                { controller.fieldsDisabled ? 'Clear User' : 'Apply User' }
              </Button>
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
    </FormProvider>
  );
};
